import api from 'api';
import { useReduxState } from 'hooks';
import { ConfirmButton } from 'components/common';

interface Props {
  courseId: number;
  updateCourses: () => Promise<void>;
}

const CoursesTileRemoveAdded = ({ courseId, updateCourses }: Props) => {
  const { messages, user } = useReduxState();

  const handleRemove = async () => {
    await api.delete(`/admin/courses/${courseId}/users?UserId=${user.id}`);
    await updateCourses();
    return true;
  };

  return (
    <ConfirmButton
      actionText={messages.commonRemove}
      buttonIcon="trash-alt"
      buttonIsDropdown={true}
      buttonText={messages.coursesRemoveMyCourse}
      category="danger"
      confirmText={messages.commonRemoveCourseConfirm}
      confirmTitle={messages.coursesRemoveMyCourse}
      onConfirm={handleRemove}
      stopPropagation={true}
      successMessage={messages.coursesRemoveMyCourseSuccess}
    />
  );
};

export default CoursesTileRemoveAdded;
